import React from 'react';
import { TextField, Box, Grid } from '@mui/material';

export default function CustomInputRange({ labelText, handleChange, fromLabelName, fromTextValue, toLabelName, toTextValue }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <label htmlFor="custom-input" style={{ fontWeight: 500 }}>
                {labelText}
            </label>
            <Grid container flexDirection={'row'} spacing={1}>
                <Grid item size={6}>
                    <TextField
                        id="custom-input"
                        name={fromLabelName}
                        variant="outlined"
                        placeholder={`From`}
                        value={fromTextValue}
                        onChange={handleChange}
                        type='number'
                        size='small'
                    />
                </Grid>
                <Grid item size={6}>
                    <TextField
                        id="custom-input"
                        name={toLabelName}
                        variant="outlined"
                        placeholder={`To`}
                        value={toTextValue}
                        onChange={handleChange}
                        type='number'
                        size='small'
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
